import { useEffect, useState } from 'react';
import { companyThemeApi } from '../../services/api';

/**
 * Object URL for a theme logo. The logo endpoints need the access token, so
 * the image is fetched as a blob instead of pointing `<img src>` at the API.
 * The URL carries the file hash (`?v=`), so a new logo is fetched again.
 */
export function useThemeLogo(logoUrl: string | null | undefined) {
  const [src, setSrc] = useState<string | null>(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    setFailed(false);
    if (!logoUrl) {
      setSrc(null);
      return;
    }
    let objectUrl: string | null = null;
    let cancelled = false;
    Promise.resolve()
      .then(() => companyThemeApi.fetchLogo(logoUrl))
      .then(blob => {
        if (cancelled) return;
        objectUrl = URL.createObjectURL(blob);
        setSrc(objectUrl);
      })
      .catch(() => {
        if (!cancelled) {
          setSrc(null);
          setFailed(true);
        }
      });
    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [logoUrl]);

  return { src, failed };
}
